import React, { useEffect } from 'react';
import { ICampaign, IDevice } from '../interfaces';
import { ChartFreeSpace } from './Charts';

const Week = (props: {
    campaigns: ICampaign[];
    devices: {
        [key: number]: IDevice;
    };
    start: Date;
    onReturnToPanel: () => void;
    onNextWeek: () => void;
    onPrevWeek: () => void;
}) => {
    const onReturnToPanel = props.onReturnToPanel;
    const onNextWeek = props.onNextWeek;
    const onPrevWeek = props.onPrevWeek;

    useEffect(() => {
        const onKeyPress = (e: KeyboardEvent) => {
            if (e.code === 'ArrowLeft' || e.keyCode === 4) {
                onPrevWeek();
            } else if (e.code === 'ArrowRight' || e.keyCode === 5) {
                onNextWeek();
            } else if (e.code === 'ArrowUp' || e.keyCode === 29460 || e.keyCode === 88) {
                onReturnToPanel();
            }
        };

        window.addEventListener('keydown', onKeyPress);

        return () => {
            window.removeEventListener('keydown', onKeyPress);
        };
    }, [onReturnToPanel, onNextWeek, onPrevWeek]);

    return (
        <div style={{ height: 'calc(100% - 50px)' }}>
            <ChartFreeSpace
                campaigns={props.campaigns}
                start={props.start}
                end={new Date(new Date(props.start).setDate(props.start.getDate() + 7))}
                devices={Object.keys(props.devices).map(parseInt)}
                height="100%"
            />
        </div>
    );
};

export default Week;
